module.exports = "https://cdn-challenge.mathletics.com/app/111/assets/images/8a37cad7a9e4fd6e3d7ceff1700f5927.png";